export const ROUTE_HOME = '/';
export const ROUTE_HELP = '/help';
export const ROUTE_SETTINGS = '/settings';
export const ROUTE_RESOURCES = '/resources';
export const ROUTE_EDITOR = '/editor';
export const ROUTE_CONFIGURATION = '/configuration';
